export const ethiopiaCities = [
    {
        city: 'Addis Ababa',
        neighborhoods: [
            'Piasa',
            '4kilo',
            'Kasanchis',
            'Bole',
            'Mexico',
            'Lafto',
            'Kera',
        ],
    },
    {
        city: 'Dire Dawa',        
        neighborhoods: [],
    },
    {
        city: "Mek'ele",
        neighborhoods: [],
    },
    {
        city: 'Bahir Dar',
        neighborhoods: [],
    },
    {
        city: 'Gonder',
        neighborhoods: [],
    },
    {
        city: 'Dessie',
        neighborhoods: [],
    },
    {
        city: 'Awasa',
        neighborhoods: [],
    },
    {
        city: 'Jimma',
        neighborhoods: [],
    },
    {
        city: 'Bishoftu',
        neighborhoods: [],
    },
    {
        city: 'Harar',
        neighborhoods: [],
    },
    {
        city: 'Debre Birhan',
        neighborhoods: [],
    },
    {
        city: 'Jigjiga',
        neighborhoods: [],
    },
    {
        city: 'Shashemanae',
        neighborhoods: [],
    },
]